<template>
    <model-modal
        component="v-spa-mixed-modal"
        :model-class="modelClass" 
        modal-type="form"
        @opening="onOpening"
        @opened="onOpened"
        @resetted="onReset"
        ref="modal"
    >
        <template v-slot:default="slotProps">
            <h2 class="mb-4 text-xl">{{ $t('worksites._page.add_button') }}</h2>
            <form @submit.prevent="submit">
                <div class="mb-6">
                    <div class="relative">
                        <v-spa-input
                            ref="inputTitle"
                            :label="$t('worksite.form.labels.title')"
                            id="create-worksite-form-title"
                            :form="form"
                            input-name="title"
                            :class-name="`${$spa.css.form.input} pl-10`"
                            container-class-name="flex flex-wrap"
                            :display-error="false"
                        ></v-spa-input>
                        <div class="absolute bottom-0 left-0 pb-[10px] pl-[10px]" slot="after-input">
                            <v-spa-submenu-container position="left-0" ref="colorSubmenu">
                                <template v-slot:default="slotProps">
                                    <div class="w-[18px] h-[18px] rounded-full cursor-pointer" @click.prevent="slotProps.toggle()" :style="`background-color: ${form.color}`"></div>
                                </template>
                                <template v-slot:submenu>
                                    <div class="w-[300px] p-4">
                                        <div class="flex flex-wrap -mx-1 -mb-2">
                                            <div class="px-1 mb-2" v-for="color in colors" :key="color"><span class="block w-6 h-6 border-2 border-white rounded-full cursor-pointer hover:shadow" :style="{'background': color}" @click.prevent="setColor(color)"></span></div>
                                        </div>
                                    </div>
                                </template>
                            </v-spa-submenu-container>
                        </div>
                    </div>
                    <v-spa-error :form="form" input-name="title"></v-spa-error>
                </div>

                <!-- <v-spa-element
                    :form="form"
                    id="create-worksite-contact"
                    input-name="contact_uuid"
                    :label="$t('form.labels.contact.name')"
                >
                    <v-spa-meilisearch-contacts-search v-model="searchedContact" />
                </v-spa-element> -->

                <v-spa-meilisearch-contacts-search-form-compatible
                    :form="form"
                    id="create-worksite-contact"
                    input-name="contact_uuid"
                    :on-init="initContact"
                    :on-create="onContactCreate"
                    :on-edit="onContactEdit"
                    :on-contact-updated="setContact"
                />
                
                <div>
                    <v-spa-address-input ref="addressInput" :label="$t('worksite.form.labels.address')" id="create-worksite-form-address" :form="form" input-name="address"></v-spa-address-input>
                    <div class="mb-6 -mt-6" v-if="contact && contact.address_line_1 && ! form.address">
                        <a href="#" class="text-xs text-gray-400 hover:text-gray-800" @click.prevent="useContactAddress">
                            {{ $t('worksite.form.use_contact_address') }}
                        </a>
                    </div>
                </div>
                
                <v-spa-multiselect :label="$t('worksite.form.labels.managers')" id="create-worksite-form-managers_id" :form="form" input-name="managers_id" :options="$store.getters.usersWithAdminRole" option-label="name" track-by="id"></v-spa-multiselect>

                <v-spa-multiselect :label="$t('worksite.form.labels.users')" id="create-worksite-form-users_id" :form="form" input-name="users_id" :options="$store.getters.usersWithWorkerRole" option-label="name" track-by="id"></v-spa-multiselect>

                <v-spa-submenu-container container="absolute z-[100] bottom-full left-0 shadow-lg bg-white whitespace-nowrap rounded" ref="datesSubmenu">
                    <template v-slot:default="slotProps">
                        <v-spa-label :form="form" id="create-worksite-form-dates" :label="$t('worksite.form.labels.dates')"></v-spa-label>
                        <div :class="`${$spa.css.form.input} flex mb-6 cursor-pointer items-center`" @click.prevent="onDatesClick">
                            <div class="mr-4">
                                <i class="text-lg text-gray-700 fas fa-calendar"></i>
                            </div>
                            <div>
                                <span class="text-sm text-gray-700">{{ $t('worksite.form.labels.selected_dates', {start: $moment(form.starts_at).format('DD MMMM YYYY'), end: $moment(form.ends_at).format('DD MMMM YYYY')}) }}</span>
                            </div>
                        </div>
                    </template>
                    <template v-slot:submenu>
                        <div class="w-auto">
                            <date-picker
                                class="!border-0"
                                v-model="range"
                                mode="range" 
                                :is-inline="true"
                                :locale="$i18n.locale"
                                :attributes="[
                                    {
                                        key: 'today',
                                        dot: true,
                                        dates: new Date(),
                                    },
                                ]"
                                :columns="2"
                                :step="1"
                                @input="dateSelected"
                            />
                        </div>
                    </template>
                </v-spa-submenu-container>
                
                <div class="flex justify-end max-w-input">
                    <v-spa-loading-button :loading="form.isLoading()">
                        {{ slotProps.model ? $t('worksite.form.buttons.edit') : $t('worksite.form.buttons.create') }}
                    </v-spa-loading-button>
                </div>
            </form>
        </template>
    </model-modal>
</template>

<script>
    import { mapState } from "vuex";
    import Form from '~spa/classes/Form';
    import DatePicker from 'v-calendar/lib/components/date-picker.umd';
    import { Type } from "@spa/api/app";
    import ModelModal from '@spa/apps/trustup-pro-base-js/components/Model/Modal';
    import Worksite from '@spa/apps/trustup-pro-worksite-js/models/Worksite';

    export default {
        components: {
            ModelModal,
            DatePicker,
        },
        
        data() {
            return {
                modelClass: Worksite,
                colors: null,
                form: new Form({
                    title: '',
                    color: '',
                    address: '',
                    starts_at: '',
                    ends_at: '',
                    contact_uuid: null,
                    managers_id: [],
                    users_id: []
                }),
                range: null,
                contact: null
            }
        },

        methods: {
            async onOpening(data)
            {
                this.initForm();

                if ( this.$refs.modal.model ) {
                    this.form.fill( this.$refs.modal.model.data() );
                    this.form.users_id = this.$refs.modal.model.getUsers();
                    this.form.managers_id = this.$refs.modal.model.getManagers();
                    this.setRange();
                    if ( ! this.form.color ) {
                        this.setRandomColor();
                    }
                }
            },

            async onOpened()
            {
                await this.$nextTick();
                await this.$nextTick();
                this.$refs.inputTitle.$refs.input.focus();
            },

            onReset()
            {
                this.form.reset();
                this.form.stop();
            },

            initForm()
            {
                this.colors = window.app.displayColors;
                this.setRandomColor();
                this.form.starts_at = window.moment().format('YYYY-MM-DD');
                this.form.ends_at = window.moment().add(1, 'week').format('YYYY-MM-DD');
                this.setRange();
                this.form.users_id = [this.$store.state.user];
                this.form.managers_id = [this.$store.state.user];
            },

            setColor(color) {
                this.form.color = color;
                this.$refs.colorSubmenu.hide();
            },

            setRandomColor()
            {
                this.form.color = this.colors[ Math.floor(Math.random() * this.colors.length) ];
            },

            setContact(contact)
            {
                this.contact = contact;
                return this;
            },

            useContactAddress()
            {
                this.$refs.addressInput.$refs.autocomplete.update(
                    `${this.contact.address_line_1 || ''} ${this.contact.address_line_2 || ''} ${this.contact.postal_code || ''} ${this.contact.city || ''} ${this.contact.country || ''}`
                );
                this.$refs.addressInput.$refs.autocomplete.focus();
                this.$nextTick(() => {
                    window.google.maps.event.trigger(this.$refs.addressInput.$refs.autocomplete.$el, 'focus', {});
                });
            },
            
            setRange()
            {
                this.range = {
                    start: window.moment(this.form.starts_at).toDate(),
                    end: window.moment(this.form.ends_at).toDate()
                };
            },

            onDatesClick()
            {
                this.setRange();
                this.$refs.datesSubmenu.show();
            },

            dateSelected(event)
            {
                console.log('wow');
                this.form.starts_at = window.moment(event.start).format('YYYY-MM-DD');
                this.form.ends_at = window.moment(event.end).format('YYYY-MM-DD');
                // this.setRange();
                // this.$refs.datesSubmenu.hide();
            },

            submit()
            {
                if ( this.form.isLoading() ) {
                    return;
                }
                
                this.form.load();
                let data = this.form.data();
                data.managers_id = data.managers_id.map(user => user.id);
                data.users_id = data.users_id.map(user => user.id);
                let action = this.$refs.modal.model ? 'update' : 'store';
                let params = this.$refs.modal.model ? {uuid: this.$refs.modal.model.uuid, data: data} : data;

                window.Worksite.endpoints.worksite[action](params).then(worksite => {
                    /** If contact was not yet processed by meilisearch queue, fake it in response. */
                    if (!worksite.contact && worksite.contact_uuid) worksite.contact = this.contact;
                    this.$refs.modal.close();
                })
                .catch((data) => {
                    this.form.onFail(data);
                });
            },

            initContact(api)
            {
                if (!this.worksite?.contact) return;
                api.setContact(this.worksite.contact);
            },

            /**
             * @param {import('@spa/types/bus').EventBusListenerParams<'contacts.create', import('@spa/types/bus').PackageEventBusEvents>} params
             * @returns {import('@spa/types/bus').EventBusListenerParams<'contacts.create', import('@spa/types/bus').PackageEventBusEvents>}
             */
            onContactCreate(params)
            {
                /** @type {(contact: import('@spa/types/api/app/contact').ContactNotPersistedInterface) => import('@spa/types/api/app/contact').ContactNotPersistedInterface)} */
                const onInit = contact => {
                    contact.types = new Type().translate([{ name: 'customer' }]);
                    return params.onInit(contact);
                }

                return {
                    onInit,
                    options: this.createOrEditOptions(params)
                }
            },

            /**
             * @param {import('@spa/types/bus').EventBusListenerParams<'contacts.edit', import('@spa/types/bus').PackageEventBusEvents>} params
             * @returns {import('@spa/types/bus').EventBusListenerParams<'contacts.edit', import('@spa/types/bus').PackageEventBusEvents>}
             */
            onContactEdit(params)
            {
                return {
                    ...params,
                    options: this.createOrEditOptions(params)
                }
            },

            /**
             * @param {import('@spa/types/bus').EventBusListenerParams<'contacts.edit', import('@spa/types/bus').PackageEventBusEvents>} params
             * @returns {import('@spa/types/components').CompleteContactFormOptions}
             */
            createOrEditOptions(params)
            {
                return {
                    ...params?.options,
                    hide: {
                        ...params?.options?.hide,
                        types: true
                    }
                }
            },
        }
    }
</script>